import React, { FC, ReactNode } from 'react';
import cx from 'classnames';

import { Card, Paragraph, Title } from 'components/ui';
import { Override } from 'types/common';
import { CardProps } from 'types/components';

import styles from './styles.module.css';

type CardViewProps = Override<CardProps, {
  titleClassName?: string;
  captionClassName?: string;
  title: ReactNode;
  caption?: ReactNode;
  type?: 'default' | 'secondary';
}>

const CardView: FC<CardViewProps> = ({
  className,
  titleClassName,
  captionClassName,
  title,
  caption,
  children,
  type = 'default',
  ...props
}) => {
  return (
    <Card
      className={cx(
        styles.root,
        styles[`root_${type}`],
        className,
      )}
      {...props}
    >
      <div className={styles.header}>
        <Title className={cx(styles.title, titleClassName)} level={3}>
          {title}
        </Title>
        <Paragraph
          className={cx(styles.caption, captionClassName)}
          type="secondary"
          hidden={!caption}
        >
          {caption}
        </Paragraph>
      </div>
      {children}
    </Card>
  );
};

export default CardView;
